import { string, node, number } from 'prop-types';
import React, { Fragment, PureComponent } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from 'reactor/components';
import { THEME } from 'reactor/common';

import styles from './Tooltip.style';

class Tooltip extends PureComponent {
  static propTypes = {
    children: node.isRequired,
    title: string,
    top: number,
    left: number,
  };

  static defaultProps = {
    title: undefined,
    top: undefined,
    left: undefined,
  };

  render() {
    const {
      props: {
        children,
        title,
        top,
        left,
      },
    } = this;
    let containerStyles = styles.container;
    if (top !== undefined && left !== undefined) {
      containerStyles = StyleSheet.compose(
        styles.container,
        {
          top: top - THEME.SPACE.S,
          left: left + THEME.SPACE.S,
        },
      );
    }
    return (
      <View style={containerStyles}>
        <View style={styles.arrow} />
        <Fragment>
          { title && (<Text body level={1} lighten style={styles.title}>{title}</Text>)}
          { children }
        </Fragment>
      </View>
    );
  }
}

export default Tooltip;
